import React from "react"
import autobind from "class-autobind"
import FormField from "./FormField"

type KeyValuePair = {
  key: string;
  value: any; // Use 'any' or a more specific type as needed
}

interface IProps {
    formJSON: string
    formData: string
    setFormData(formData: string): void
}

interface IState {
  data:KeyValuePair[]
}

export default class ScheduledJobForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
          data: props.formData ? JSON.parse(props.formData) : []
        }        
        autobind(this)
    }
     
    render() {     
      const changeValue = (key, value) => {
          const item = this.state.data ? this.state.data.find(item => item.key == key) : null
          if(item){
            item.value = value
            this.setState({data: this.state.data})
          }else{
            this.state.data.push({key: key, value: value})
          }

          this.props.setFormData(JSON.stringify(this.state.data))
      }

      const defaultJsonForm = `
{
  "fields": 
  [
      {
        "component": "text-field",
        "name": "sampleTextField",
        "label": "Sample Text"
      },
      {
        "component": "date-field",
        "name": "sampleDateField",
        "label": "Sample Date"
      },
      {
        "component": "date-field-chip-set",
        "name": "sampleDateFieldChipSet",
        "label": "Sample Date Field Chip Set"
      },
      {
        "component": "text-field-chip-set",
        "name": "sampleTextFieldChipSet",
        "label": "Sample Text Field Chip Set"
      }          
    ]
}`

      let schema = JSON.parse(defaultJsonForm)
      
      if(this.props.formJSON){
        try {
          schema = JSON.parse(this.props.formJSON)
        } catch(e){
          console.log(e)
        }
      }

      return (
        <div style={{padding: 20}}>
          {schema.fields && schema.fields.map((field, index) => {
            const item = this.state.data ? this.state.data.find(item => item.key == field.name) : null
            let value = ""

            if(item){
              value = item.value
            }

            return (
              <span style={{marginRight: 10}}>
                <FormField 
                  field={field} 
                  value={value} 
                  key={index}
                  onChange={changeValue}
                />
              </span>
            )
          })}
        </div>
      )
    }
}